import React, { useState } from "react";
import { useMobile } from "../hooks/useMobile";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import DealsListPage from "./DealsListPage";
import CommissionDashboard from "./CommissionDashboard";
import OwnerPipeline from "./OwnerPipeline";

export default function DealsPage() {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const navigate = useNavigate();
  const mobile = useMobile();

  const isOwnerOrManager =
    user.role === "owner" ||
    (user.role === "broker" && (user.brokerLevel === "owner" || user.brokerLevel === "manager"));

  const tabs = [
    { key: "deals",       label: "Deals",       icon: "💼" },
    { key: "commissions", label: "Commissions",  icon: "💰" },
    ...(isOwnerOrManager ? [{ key: "pipeline", label: "Pipeline", icon: "🏦" }] : []),
  ];

  const [tab, setTab] = useState("deals");

  return (
    <div className="broker-dashboard">
      <Sidebar />
      <main style={{ flex: 1, marginLeft: mobile ? 0 : 70, display: "flex", flexDirection: "column", overflow: "hidden", minWidth: 0 }}>

        {/* Page header + tab bar */}
        <div style={{ padding: "28px 32px 0", borderBottom: "1px solid #e5e7eb", background: "#fff" }}>
          <div style={{ marginBottom: 20 }}>
            <h1 style={{ margin: 0, fontSize: 26, fontWeight: 700, color: "#0e1b2c" }}>Deals</h1>
            <p style={{ margin: "4px 0 0", color: "#6b7280", fontSize: 14 }}>
              {tab === "deals"       && "All your active and historical deals"}
              {tab === "commissions" && "Commission earnings — pipeline, payable and paid"}
              {tab === "pipeline"    && "Company-wide pipeline across your whole team"}
            </p>
          </div>
          <div style={{ display: "flex", gap: 0 }}>
            {tabs.map(t => (
              <button key={t.key} onClick={() => setTab(t.key)}
                style={{
                  background: "none", border: "none", padding: "10px 22px",
                  fontSize: 14, fontWeight: tab === t.key ? 700 : 500,
                  color: tab === t.key ? "#0e1b2c" : "#6b7280",
                  borderBottom: tab === t.key ? "3px solid #0e1b2c" : "3px solid transparent",
                  cursor: "pointer", display: "flex", alignItems: "center", gap: 7,
                  transition: "all 0.15s",
                }}>
                {t.icon} {t.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tab content */}
        <div style={{ flex: 1, overflow: "auto" }}>
          {tab === "deals"       && <DealsListPage noLayout />}
          {tab === "commissions" && <CommissionDashboard noLayout />}
          {tab === "pipeline"    && isOwnerOrManager && <OwnerPipeline noLayout />}
        </div>

      </main>
    </div>
  );
}
